import type { ReactNode, JSX } from 'react'

import { Heading } from '@buffer-mono/popcorn'

import styles from './SectionHeader.module.css'

type SectionHeaderProps = {
  children: ReactNode
  id?: string
}

export function SectionHeader({
  children,
  id,
}: SectionHeaderProps): JSX.Element {
  return (
    <Heading as="h2" size="xs" id={id} className={styles.heading}>
      {children}
    </Heading>
  )
}
